import { Component, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { HttpService } from './http.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  title = 'panel';
  @ViewChild("notification") notification : ElementRef;
  @ViewChild("notification_tone") notification_tone : ElementRef;
  @ViewChild("chat") chat : ElementRef;

  constructor(private api: HttpService) {
    this.api.getSelectedCompany().subscribe((company_id) => {

      if (company_id) {
        var iden = this.api.getIdentifier();
        if (!iden.status) {
          iden = this.api.createIdentifier();
        } else {
          iden = iden.identifier;
        }

      }
    })

    this.api.initNotification();

    // Unlock audio on the first user interaction after page load so future
    // live-chat rings can play (browsers block autoplay without a gesture).
    const unlock = () => {
      this.api.primeAudio("notification");
      document.removeEventListener('click', unlock, true);
      document.removeEventListener('keydown', unlock, true);
      document.removeEventListener('touchstart', unlock, true);
    };
    document.addEventListener('click', unlock, true);
    document.addEventListener('keydown', unlock, true);
    document.addEventListener('touchstart', unlock, true);
  }


  ngOnDestroy(): void {
    this.api.closeAllWindow();
  }
  
}
